// ACTIONS
export const ADD_TO_BASKET = '[Basket] add offer to basket';
export const addToBasket = (payload) => ({ type: ADD_TO_BASKET, payload });
export const REMOVE_FROM_BASKET = '[Basket] remove offer from basket';
export const removeFromBasket = (payload) => ({ type: REMOVE_FROM_BASKET, payload });
export const ADD_AMOUNT = '[Basket] add amount to offer';
export const addAmount = (payload) => ({ type: ADD_AMOUNT, payload });
export const SUB_AMOUNT = '[Basket] sub amount from offer';
export const subAmount = (payload) => ({ type: SUB_AMOUNT, payload });
// export const SET_PRODUCER = '[Basket] set producer name';
// export const setProducerData = (payload) => ({ type: SET_PRODUCER, payload });
export const CLEAR_BASKET = '[Basket] clear';
export const clearBasket = () => ({ type: CLEAR_BASKET });

// REDUCER
const INITIAL_STATE = {
  // producerData: undefined, // TODO: remove this
  producerId: '',
  offers: [],
};

export default function BasketReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
  /* case SET_PRODUCER:
    return {
      ...state,
      producerData: action.payload,
    }; */

  case ADD_TO_BASKET:
    if (state.producerId !== action.payload.producerId) {
      return {
        ...state,
        producerId: action.payload.producerId,
        offers: [
          {
            id: action.payload.id,
            amount: action.payload.amount,
          },
        ],
      };
    }

    if (state.offers.filter((offer) => offer.id === action.payload.id).length > 0) {
      return {
        ...state,
        offers: state.offers.map((offer) => {
          if (offer.id === action.payload.id) {
            return {
              id: offer.id,
              amount: offer.amount + action.payload.amount,
            };
          }

          return offer;
        }),
      };
    }

    return {
      ...state,
      offers: [
        ...state.offers,
        {
          id: action.payload.id,
          amount: action.payload.amount,
        },
      ],
    };

  case REMOVE_FROM_BASKET:
    const newArray = state.offers.filter((offer) => offer.id !== action.payload.id);
    return {
      ...state,
      producerId: newArray.length > 0 ? state.producerId : '',
      offers: newArray,
    };

  case ADD_AMOUNT:
    return {
      ...state,
      offers: state.offers.map((offer) => {
        if (offer.id === action.payload.id) return { id: offer.id, amount: offer.amount + 1 };
        return offer;
      }),
    };

  case SUB_AMOUNT:
    return {
      ...state,
      offers: state.offers.map((offer) => {
        if (offer.id === action.payload.id) return { id: offer.id, amount: offer.amount - 1 };
        return offer;
      }),
    };

  case CLEAR_BASKET:
    return INITIAL_STATE;

  default:
    return state;
  }
}
